<template>
  <section v-if="filteredDoctors.length">
    <div class="section-inner">
      <div class="si-head">
        <h2>Dokter Terkait</h2>
      </div>

      <div class="si-body">
        <div class="card-list">
          <div 
            class="doctor-card" 
            v-for="doctor in filteredDoctors" 
            :key="doctor.slug"
          >
            <img 
              class="doctor-photo" 
              :src="doctor.profile" 
              :alt="doctor.name" 
              v-if="doctor.profile"
            />
            <img src="../../assets/images/pictures/emptyphoto.jpg" class="doctor-photo" alt="rs melinda 2" v-else/>
            <div class="doctor-info">
              <h3>{{ doctor.name }}</h3>
              <h4>{{ doctor.specialist_name }}</h4>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-else>
        <p>Tidak ada dokter terkait untuk kategori ini.</p>
      </div> -->
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useDoctorStore } from "@/stores/doctor";

const route = useRoute();
const serviceSlug = route.params.slug;

const doctorsData = computed(() => useDoctorStore().rawDoctors);

const serviceDoctorMapping = {
  "unit-gawat-darurat": {
    specialists: ["umum"],
    doctors: []
  },
  "endokrinologi-anak": {
    specialists: ["anak"],
    doctors: []
  },
  "tulang-belakang": {
    specialists: ["orthopaedi-dan-traumatologi"],
    doctors: []
  },
  "bedah-umum": {
    specialists: ["bedah-umum"],
    doctors: []
  },
  "bandung-urology-center": {
    specialists: ["urologi"],
    doctors: []
  },
  "klinik-psikologi": {
    specialists: ["psikologi"],
    doctors: []
  },
  "poliklinik-psikiatri": {
    specialists: ["psikiatri"],
    doctors: []
  },
  "one-day-surgery": {
    specialists: ["bedah-umum", "bedah-konsultan-vaskuler", "bedah-onkologi", "bedah-konsultan-digestifpencernaan", "bedah-anak"],
    doctors: []
  },
  "upper-limb-microsurgery": {
    specialists: ["bedah-umum"],
    doctors: []
  },
  "pediatric-neonatology": {
    specialists: [""],
    doctors: []
  },
  "orthopaedi-dan-traumatologi-umum-dan-pediatric-orthopaedi": {
    specialists: ["orthopaedi-dan-traumatologi"],
    doctors: []
  },
  "spesialis-kedokteran-olahraga": {
    specialists: ["kedokteran-olahraga"],
    doctors: []
  },
  "gynecologyc-surgery": {
    specialists: ["obgyn"],
    doctors: []
  },
  "bedah-onkologi": {
    specialists: ["bedah-onkologi"],
    doctors: []
  },
  "bedah-digestif": {
    specialists: ["bedah-konsultan-digestifpencernaan"],
    doctors: []
  },
  "cedera-olahraga": {
    specialists: ["kedokteran-olahraga"],
    doctors: []
  },
  "bedah-plastik-rekontruksi-estetik": {
    specialists: ["bedah-plastik-rekonstruksi-estetik"],
    doctors: []
  },
  "melinda-child-development-center": {
    specialists: ["anak"],
    doctors: []
  },
  "playground": {
    specialists: [""],
    doctors: []
  },
  "ambulance": {
    specialists: [""],
    doctors: []
  },
  "pediatric-surgery": {
    specialists: ["bedah-anak"],
    doctors: []
  },
  "cafe": {
    specialists: [""],
    doctors: []
  },
  "bedah-saraf": {
    specialists: ["bedah-saraf"],
    doctors: []
  },
  "roft-toop": {
    specialists: [""],
    doctors: []
  },
  "kamar-bayi": {
    specialists: [""],
    doctors: []
  },
  "hydroterapy-pool": {
    specialists: [""],
    doctors: []
  },
  "general-support-services": {
    specialists: [""],
    doctors: []
  },
  "gymnasium": {
    specialists: [""],
    doctors: []
  },
  "radiologi": {
    specialists: ["lab-radiologi"],
    doctors: []
  },
  "farmasi": {
    specialists: [""],
    doctors: []
  },
  "kamar-operasi": {
    specialists: [""],
    doctors: []
  },
  "rawat-inap": {
    specialists: [""],
    doctors: []
  },
};

const filteredDoctors = computed(() => {
  if (!doctorsData.value) return [];

  const config = serviceDoctorMapping[serviceSlug] || {};
  const specialistSlugs = config.specialists || [];
  const doctorIds = config.doctors || [];

  let doctors = doctorsData.value
    .filter(group => specialistSlugs.includes(group.specialist_slug))
    .flatMap(group => group.doctors);

  if (doctorIds.length > 0) {
    doctors = doctors.filter(doc => doctorIds.includes(doc.slug));
  }

  doctors = doctors.sort(() => Math.random() - 0.5);

  return doctors.slice(0, 4);
});

useDoctorStore().setData();
</script>

<style scoped>
section{
  padding: 2.5rem 10%;
  background: var(--cream-bg);
}
.si-head h2{
  font-size: 1.5rem;
  color: var(--navy);
  margin-bottom: 1rem;
}
.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 280px));
  gap: 1.5rem;
}

.doctor-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  overflow: hidden;
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}

.doctor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.12);
}

.doctor-photo {
  width: 200px;
  height: unset;
  margin-bottom: 1rem;
}

.doctor-info h3 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--navy);
  margin: 0;
}

.doctor-info h4 {
  font-size: 0.9rem;
  font-weight: 400;
  color: var(--grey);
  margin-top: 0.3rem;
}

@media only screen and (max-width: 1500px){
    section{
        padding: 2.5rem 5% 2.5rem 5%;
    }
}
@media only screen and (max-width: 750px){
    section{
        padding: 2.5rem 2.5% 2.5rem 2.5%;
    }
}
</style>
